import { FACTORY_ORDER_PRIORITY } from '../constants/carOrigin';

const sortFactoryList = (list = []) => {
  const priority = FACTORY_ORDER_PRIORITY.map((name) => name.toLowerCase());
  const rank = (factory) => {
    const idx = priority.indexOf((factory?.name ?? '').toLowerCase());
    return idx === -1 ? Number.MAX_SAFE_INTEGER : idx;
  };

  return [...list].sort((a, b) => rank(a) - rank(b));
};

export default sortFactoryList;
